import { render, staticRenderFns } from "./BlogImageUpload.vue?vue&type=template&id=2b639f38&scoped=true"
import script from "./BlogImageUpload.vue?vue&type=script&lang=js"
export * from "./BlogImageUpload.vue?vue&type=script&lang=js"
import style0 from "./BlogImageUpload.vue?vue&type=style&index=0&id=2b639f38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b639f38",
  null
  
)

export default component.exports